import { css } from '@emotion/react';
import { mediaQuery } from '../helpers';
import { tokens } from '../tokens';
import { panelEnter, panelExit } from './keyframes';
const drawerStaticStyle = css({
    borderRadius: 0,
    bottom: 0,
    minWidth: 'unset',
    opacity: 1,
    position: 'fixed',
});
const PANEL_MAX_WIDTH_BELOW_MEDIUM_BREAKPOINT = '416px';
const PANEL_MAX_WIDTH_ABOVE_SMALL_BREAKPOINT = '600px';
const PANEL_MAX_HEIGHT = '75vh';
export function drawerStyle({ isVisible, placement }) {
    const isVertical = placement === 'bottom';
    const smallOffset = isVertical
        ? PANEL_MAX_HEIGHT
        : PANEL_MAX_WIDTH_BELOW_MEDIUM_BREAKPOINT;
    const largeOffset = isVertical
        ? PANEL_MAX_HEIGHT
        : PANEL_MAX_WIDTH_ABOVE_SMALL_BREAKPOINT;
    const direction = placement === 'left' ? -1 : 1;
    return [
        drawerStaticStyle,
        css(Object.assign({ animation: `${isVisible
                ? panelEnter({
                    offset: smallOffset,
                    slideFrom: placement,
                })
                : panelExit({
                    offset: smallOffset,
                    slideFrom: placement,
                })} 200ms cubic-bezier(0, 0, 0.6, 1) forwards`, [placement]: 0, transform: `translateX(calc(${direction} * ${smallOffset}))`, [mediaQuery.aboveSmall]: {
                animation: `${isVisible
                    ? panelEnter({
                        offset: largeOffset,
                        slideFrom: placement,
                    })
                    : panelExit({
                        offset: largeOffset,
                        slideFrom: placement,
                    })} 200ms cubic-bezier(0, 0, 0.6, 1) forwards`,
                maxWidth: isVertical
                    ? '100%'
                    : `min(calc(100vw - ${tokens.spacing.xxlarge}), ${largeOffset})`,
                transform: `translateX(calc(${direction} * ${largeOffset}))`,
            } }, (isVertical
            ? {
                maxHeight: largeOffset,
                width: '100%',
            }
            : {
                height: '100vh',
                width: `min(calc(100vw - ${tokens.spacing.xxlarge}), ${largeOffset})`,
            }))),
    ];
}
